import Link from "next/link";
import { V3TertiaryCTAColor, V3TertiaryLinkProps } from "../Button/V3TertiaryCTA.types";
import React from "react";
import { V3TertiaryCTALink } from "./V3TertiaryLink.styles";
import { TCTACommon } from "../Button";

export const V3TertiaryLink = ({
    iconPosition,
    icon,
    text,
    ctaColor = V3TertiaryCTAColor.color,
    useNextRouter = true,
    skipSVGColor = false,
    href,
    ...rest
}: V3TertiaryLinkProps) => {
    const ElemToUse = useNextRouter ? Link : React.Fragment;

    const props: any = {};

    if (useNextRouter) {
        props.useNextRouter = true;
        props.href = href!;
        props.legacyBehavior = true;
    }

    return (
        <ElemToUse {...props}>
            <V3TertiaryCTALink $ctaColor={ctaColor} href={href} $skipSVGColor={skipSVGColor} {...rest}>
                <TCTACommon iconPosition={iconPosition} icon={icon} text={text} />
            </V3TertiaryCTALink>
        </ElemToUse>
    );
};
